import confirmMarkAsPhishing from './helpers/confirmMarkAsPhishing';
import createItemContextsForDeleteStoreUpdate from './helpers/createItemContextsForDeleteStoreUpdate';
import markItemsAsPhishingBasedOnItemIds from './helpers/markItemsAsPhishingBasedOnItemIds';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { mailStore } from 'owa-mail-store';
import { TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';

/**
 * Mark item as phishing from reading pane
 * @param itemId of the item to be marked as phishing
 * @param actionSource that triggers the action
 */
export default function markItemsAsPhishingFromReadingPane(
    itemId: string,
    tableView: TableView,
    actionSource: ActionSource
) {
    const item = mailStore.items.get(itemId);
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing(() => {
        markItemsAsPhishingBasedOnItemIds([itemId], tableView, actionSource, () => {
            const itemContexts = createItemContextsForDeleteStoreUpdate([itemId]);

            // Dispatch action to update the store state
            deleteItemsStoreUpdate(itemContexts, item.ParentFolderId.Id);
        });
    });
}
